// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"161":"poi","806":"user"}[chunkId] + "." + {"161":"7ab0167b","806":"1dc62d98"}[chunkId] + ".js";
};